export const ETH_ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/
export const ALGO_ADDRESS_REGEX = /^[A-Z2-7]{58}$/
export const LOWER_HEX_REGEX = /^0x[a-f0-9]*$/